import { createFileRoute } from "@tanstack/react-router";
import BrokerageTerms from "@/pages/BrokerageTerms";

export const Route = createFileRoute("/brokerage-terms")({
  head: () => {
    const title = "Brokerage Terms & Fee Schedule | MNRE - Mohnish Nagpal Real Estate";
    const description = "Transparent schedule of professional fees, lease brokerage, residential & commercial sale commission, and transactional terms for Mohnish Nagpal Real Estate.";
    const canonicalUrl = "https://mnre.in/brokerage-terms";
    const ogImage = "https://mnre.in/blog-covers/mumbai-legal-property-documents.jpg";

    const breadcrumbJsonLd = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "Home", item: "https://mnre.in/" },
        { "@type": "ListItem", position: 2, name: "Brokerage Terms", item: canonicalUrl },
      ],
    };

    return {
      meta: [
        { title },
        { name: "description", content: description },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:type", content: "website" },
        { property: "og:url", content: canonicalUrl },
        { property: "og:image", content: ogImage },
        { name: "twitter:card", content: "summary_large_image" },
        { name: "twitter:title", content: title },
        { name: "twitter:description", content: description },
        { name: "twitter:image", content: ogImage },
      ],
      links: [{ rel: "canonical", href: canonicalUrl }],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(breadcrumbJsonLd),
        },
      ],
    };
  },
  component: BrokerageTerms,
});
